import { getToken, getUser } from "../../Utils/Common"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import Moment from "moment"

//GET MYT FOUNDATION
// export const getAllSePayments = async (datefrom, dateto) => {
//     try {
//         const response = await getAPICall(
//             process.env.REACT_APP_LINK + "supplies_expensupplies_receive_payments/get_all_payment",
//             {
//                 requester: getUser(),
//                 token: getToken(),
//                 // status: status,
//                 start_date: datefrom,
//                 end_date: dateto,
//             }
//         );
//         //
//         return { data: response.data };
//     } catch (error) {
//         //
//         return { error: error.response };
//     }
// };

// GET NGROK
export const getAllSePayments = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_payments/get_all_payment",
      {
        requester: getUser(),
        token: getToken(),
        start_date: data.start_date
          ? Moment(data.start_date).format("YYYY-MM-DD")
          : "",
        end_date: data.end_date
          ? Moment(data.end_date).format("YYYY-MM-DD")
          : data.end_date,
        supplier_id: data.supplier_id,
        vendor_id: data.vendor_id,
        payment_mode: data.payment_mode,
        doc_no: data.doc_no,
        anything: data.anything,
        page: data.page,
      }
    )
    //
    return { data: response.data }
  } catch (error) {
    //
    return { error: error.response }
  }
}

//FILTER
export const searchByDate = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_payments/get_all_payment",
      {
        requester: getUser(),
        token: getToken(),
        start_date: Moment(data.from).format("YYYY-MM-DD"),
        end_date: data.to ? Moment(data.to).format("YYYY-MM-DD") : data.to,
        supplier_id: data.supplier_id,
        payment_mode: data.payment_mode,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//GET SINGLE CASH
export const getSingleCashSe = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_cash_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE CHECK
export const getSingleCheckSe = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_check_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE BANK
export const getSingleBankSe = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_bank_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
//GET SINGLE OTHERS
export const getSingleOtherSe = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_other_payments/get_slip",
      {
        requester: getUser(),
        token: getToken(),
        slip_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

//CREATE CHECK PAYMENT
export const createSeCheckPayment = async (newPayment, items) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("bank_id", newPayment.bank_id)
    formData.append("check_no", newPayment.check_no)
    formData.append("check_date", newPayment.check_date)
    formData.append("issued_date", newPayment.issued_date)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_check_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE CASH PAYMENT
export const createSeCashPayment = async (newPayment, items) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_cash_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE BANK PAYMENT
export const createSeBankPayment = async (newPayment, items) => {
  try {
    console.log(newPayment)
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("bank_from", newPayment.bank_from)
    formData.append("from_account_no", newPayment.from_account_no)
    formData.append("from_account_name", newPayment.from_account_name)
    formData.append("bank_to", newPayment.bank_to)
    formData.append("bank_to_name", newPayment.bank_to)
    formData.append("to_account_no", newPayment.to_account_no)
    formData.append("to_account_name", newPayment.to_account_name)
    formData.append(
      "transaction_fee",
      newPayment.transaction_fee ? newPayment.transaction_fee : 0
    )
    formData.append("reference_no", newPayment.reference_no)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_bank_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// CREATE OTHER PAYMENT
export const createSeOtherPayment = async (newPayment, items, amount) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append(`attachments[]`, file, file.name)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("transaction_type", newPayment.transaction_type)
    formData.append("amount", amount)
    formData.append("transaction_no", newPayment.transaction_no)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_other_payments/create",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE CHECK PAYMENT
export const updateCheckPayment = async (newPayment, items, id) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_receive_check_slip_id", id)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("bank_id", newPayment.bank_id)
    formData.append("check_no", newPayment.check_no)
    formData.append("check_date", newPayment.check_date)
    formData.append("issued_date", newPayment.issued_date)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_check_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE CHECK PAYMENT
export const updateCashPayment = async (newPayment, items, id) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_receive_cash_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_cash_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
// UPDATE BANK PAYMENT
export const updateBankPayment = async (
  newPayment,
  items,
  transactionFee,
  id
) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_receive_bank_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("bank_from", newPayment.bank_from)
    formData.append("from_account_no", newPayment.from_account_no)
    formData.append("from_account_name", newPayment.from_account_name)
    formData.append("bank_to", newPayment.bank_to)
    formData.append("bank_to_name", newPayment.bank_to_name)
    formData.append("to_account_no", newPayment.to_account_no)
    formData.append("to_account_name", newPayment.to_account_name)
    formData.append("transaction_fee", newPayment.transaction_fee)
    formData.append("reference_no", newPayment.reference_no)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("payee", newPayment.payee)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("acknowledged_by", newPayment.acknowledged_by.value)
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_bank_payments/update",
      formData,
      true
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// UPDATE OTHER PAYMENT
export const updateOtherPayment = async (newPayment, items, id, amount) => {
  try {
    const formData = new FormData()
    newPayment.attachments.map((file) => {
      formData.append("attachments[]", file, file.name)
      formData.append("attachment_ids[]", null)
    })
    newPayment.prev_files.map((file) => {
      formData.append("attachment_ids[]", file.id)
    })
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("supplies_receive_other_slip_id", id)
    formData.append("payment_date", newPayment.payment_date)
    formData.append("supplier_id", newPayment.supplier_id)
    formData.append("vendor_id", newPayment.vendor_id)
    formData.append("amount", amount)
    formData.append("transaction_type", newPayment.transaction_type)
    formData.append("transaction_no", newPayment.transaction_no)
    formData.append("payee", newPayment.payee)
    formData.append("acknowledged_by", newPayment.acknowledged_by)
    formData.append(
      "particulars",
      newPayment.particulars ? newPayment.particulars : ""
    )
    formData.append("withholding_tax_total", newPayment.withholding_tax_total)
    formData.append("total_amount", newPayment.total_amount)
    formData.append("subtotal", newPayment.subtotal)
    formData.append("total_others", newPayment.total_others)
    formData.append("grand_total", newPayment.grand_total)

    items.map((item) => {
      formData.append(`supplies_receive_ids[]`, item.entry.value)
      formData.append(`amounts[]`, item.amount)
      formData.append(`withholding_tax[]`, item.withholding)
      formData.append(`service_fee_payment[]`, item.other_fees)
      formData.append(`subamount[]`, item.subtotal)
      formData.append(`grand_amount[]`, item.grand_amount)
    })

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_other_payments/update",
      formData,
      true
    )

    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE CHECK
export const deleteCheckSe = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_receive_check_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK +
        "supplies_receive_check_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE ADVANCE PAYMENT
export const deleteSuppliesAdvancePayment = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_expense_payment_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_expenses/delete_payment",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE CASH
export const deleteCashSe = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_receive_cash_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_cash_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}
// DELETE Bank
export const deleteBankSe = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_receive_bank_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "supplies_receive_bank_payments/delete_slip",
      payload
    )
    //
    //
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

// DELETE CASH
export const deleteOthersSe = async (id) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      supplies_receive_other_slip_id: id,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK +
        "supplies_receive_other_payments/delete_slip",
      payload
    )
    return { data: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const createBir2037ExpensePayments = async (id, type) => {
  try {
    const formData = new FormData()
    formData.append("requester", getUser())
    formData.append("token", getToken())
    formData.append("slip_id", id)
    formData.append("payment_type", type)
    const response = await postAPICall(
      process.env.REACT_APP_LINK +
        "Birform/supplies_receive_payment_generate2307",
      formData
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
